import { render, staticRenderFns } from "./cancelOrder_view.vue?vue&type=template&id=0cb2e424&scoped=true&"
import script from "./cancelOrder_view.vue?vue&type=script&lang=js&"
export * from "./cancelOrder_view.vue?vue&type=script&lang=js&"
import style0 from "./cancelOrder_view.vue?vue&type=style&index=0&id=0cb2e424&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2e424",
  null
  
)

export default component.exports